module.exports = __webpack_public_path__ + "img/mc-r1.0a2f5ba2.gif";